import {makeStyles} from '../../theme'

export const useDrawerStyles = makeStyles(theme => ({
  drawer: {
    position: 'fixed',
    willChange: 'transform',
    bottom: 0,
    width: '100%',
    touchAction: 'none',
    backgroundColor: '#fff',
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    padding: '0',
    boxSizing: 'border-box',
    boxShadow: '0px 5px 40px rgb(0 0 0 / 25%)',
  },
  noTouchAction: {
    touchAction: 'none',
  },
  expanderWrapper: {
    position: 'absolute',
    width: '100%',
    height: 40,
    left: 0,
    top: -30,
    right: 0,
    zIndex: 10,
    lineHeight: 40,
  },
  expanded: {
    top: -12,
  },
  scrollContainer: {
    height: '100%',
    touchAction: 'none',
    display: 'flex',
    flexDirection: 'column',
  },
  scrollable: {
    overflowY: 'scroll',
    overflowX: 'hidden',
    touchAction: 'pan-y',
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    /* Disable scrollbar */
    '-ms-overflow-style': 'none' /* IE and Edge */,
    scrollbarWidth: 'none' /* Firefox */,
    /* Chrome Safari */
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  expander: {
    position: 'absolute',
    width: 80,
    height: '100%',
    left: 0,
    right: 0,
    top: 0,
    margin: '0 auto',
    cursor: 'pointer',
    '&:after': {
      content: '""',
      margin: 'auto',
      width: 40,
      height: 5,
      background: 'rgba(0, 0, 0, 0.2)',
      borderRadius: 5,
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
  },
  overlay: {
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100vw',
    height: '100vh',
    background: 'black',
    opacity: 0,
    display: 'none',
  },
  overlayVisible: {
    opacity: 0.6,
    display: 'block',
  },
  expandedOutside: {
    '&:after': {
      backgroundColor: 'rgba(255, 255, 255, 0.6)',
    },
  },
  shown: {
    display: 'block',
  },
  section: {
    backgroundColor: 'white',
    borderRadius: 24,
    boxSizing: 'border-box',
    marginBottom: theme.spacing(1),
  },
  fullHeightContent: {
    flexGrow: 1,
    marginBottom: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  closeModal: {
    position: 'absolute',
    top: -60,
    right: 60,
    zIndex: 9999,
  },
}))
